import { isFilledValue } from './isFilledValue'

export function serializeCardDateField(value, { resetWhenEmpty = false } = {}) {
  if (!isFilledValue(value)) {
    return resetWhenEmpty ? '' : undefined
  }

  if (typeof value === 'string') {
    return value
  }

  return value.toLocaleDateString()
}
